export default "__VITE_ASSET__df31e13f__"